import React from 'react';
import { HOW_IT_WORKS, BRAND } from '../../data/mock';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';

export const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block text-teal-600 font-semibold text-sm uppercase tracking-wider mb-4">
            Simple Process
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
            {HOW_IT_WORKS.title}
          </h2>
          <p className="text-lg text-slate-600">
            {HOW_IT_WORKS.subtitle}
          </p>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {HOW_IT_WORKS.steps.map((step, index) => (
            <div
              key={index}
              className="relative group"
            >
              {/* Connector line */}
              {index < HOW_IT_WORKS.steps.length - 1 && (
                <div className="hidden lg:block absolute top-12 left-full w-full h-0.5 bg-gradient-to-r from-teal-300 to-transparent z-0" />
              )}
              
              <div className="relative bg-white rounded-2xl p-6 border border-slate-100 shadow-sm hover:shadow-lg hover:border-teal-200 transition-all duration-300 h-full">
                {/* Step number */}
                <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-teal-500 to-cyan-600 flex items-center justify-center mb-5 shadow-lg shadow-teal-500/20 group-hover:scale-110 transition-transform duration-300">
                  <span className="text-white font-bold text-lg">{step.number}</span>
                </div>
                
                <h3 className="text-xl font-bold text-slate-800 mb-3">
                  {step.title}
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <Button
            asChild
            size="lg"
            className="text-white font-semibold shadow-lg shadow-orange-500/25"
            style={{ background: 'linear-gradient(135deg, #f97316 0%, #fb7185 100%)' }}
          >
            <a href={BRAND.quoteUrl} target="_blank" rel="noopener noreferrer">
              Start With Your Free Quote
              <ArrowRight className="w-5 h-5 ml-2" />
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
};
